import { Component, OnInit } from '@angular/core';
const data = {
  chart: {
    caption: '',
    placevaluesinside: '1',
    showvalues: '0',
    plottooltext: '<b>$dataValue</b>  $seriesName visitors',
    theme: 'fusion',
    paletteColors: '#1B9928,#DB7537,#EDBA06,#428DFF',
    bgColor: '#fdfdfd',
    maxBarHeight: '6'
  },
  categories: [
    {
      category: [
        {
          label: 'Male'
        },
        {
          label: 'Female'
        }
      ]
    }
  ],
  dataset: [
    {
      seriesname: 'Morning',
      data: [
        {
          value: '34899'
        },
        {
          value: '29967'
        }
      ]
    },
    {
      seriesname: 'Afternoon',
      data: [
        {
          value: '20876'
        },
        {
          value: '17038'
        }
      ]
    },
    {
      seriesname: 'Evening',
      data: [
        {
          value: '14821'
        },
        {
          value: '12967'
        }
      ]
    },
    {
      seriesname: 'Overnight',
      data: [
        {
          value: '11876'
        },
        {
          value: '7843'
        }
      ]
    }
  ]
};
@Component({
  selector: 'app-starcked-bars',
  templateUrl: './starcked-bars.component.html',
  styleUrls: ['./starcked-bars.component.scss']
})
export class StarckedBarsComponent implements OnInit {
  width = 600;
  height = 400;
  type = 'stackedbar2d';
  dataFormat = 'json';
  dataSource = data;
  constructor() { }

  ngOnInit() {
  }

}
